import styled from 'styled-components'
import theme from 'styled-theming'

import { THEME, typeScale } from '../../styles'
import ThemeIcon from '../ThemeIcon'

const VARIANTS = {
  background: theme('variant', {
    page: THEME.COLORS.background.primary,
    footer: THEME.COLORS.default.white,
  }),
  color: theme('variant', {
    page: THEME.COLORS.foreground.primary,
    footer: THEME.COLORS.default.black,
  }),
}

const Styled = styled.div``
Styled.container = styled.div`
  height: 3.2rem;
  position: relative;
  border-radius: 9999px;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: ${VARIANTS.background};
  cursor: pointer;
`
Styled.label = styled.span`
  ${typeScale('caption', { lineHeight: '3.2rem' })};
  color: ${VARIANTS.color};
  display: inline-block;
  padding: 0 0.4rem 0 0.6rem;
  user-select: none;
`
Styled.iconTheme = styled(ThemeIcon)`
  width: 1.6rem;
  height: 1.6rem;
  display: block;
  user-select: none;
`

export default Styled
